module.exports = __webpack_public_path__ + "img/background.6b1846a5.png";